<div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
  <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
    <h2 class="noMarginHeader">
      <mat-icon>bar_chart</mat-icon> Households Tied to Multiple Housing Units
    </h2><br />
  </div>
</div>

<mat-card *ngIf="loading">
  <span>Loading</span><br />
  <mat-progress-bar mode="query"></mat-progress-bar>
</mat-card>

<!-- List of Households -->
<div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start" [hidden]="loading">
  <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
    <small>Any Household that are tied to multiple Housing Units. </small><br />
  </div>
</div>
<mat-card [hidden]="loading">
  <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
    <br />
    <strong class="noMarginHeader">Total ({{size}})</strong> &nbsp;&nbsp;
     
    <br /><br />
    <mat-table [dataSource]="dataSource" matSort #TableSort="matSort" class="mat-elevation-z8"
      style="overflow-x: auto;">
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      <ng-container matColumnDef="id">
        <mat-header-cell *matHeaderCellDef mat-sort-header>OHA Household Id</mat-header-cell>
        <mat-cell *matCellDef="let result">
          <a (click)="editHousehold(result.id)"
            title="Edit Household {{result.id}}" style="cursor: pointer;">{{result.id}}</a> 
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="address1">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Address</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.address1}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="city">
        <mat-header-cell *matHeaderCellDef mat-sort-header>City</mat-header-cell> 
        <mat-cell *matCellDef="let result">
          {{result.city}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="zip">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Zip</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.zip}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="county">
        <mat-header-cell *matHeaderCellDef mat-sort-header>County</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.county}}
        </mat-cell>
      </ng-container>
    </mat-table>
    <br />
    <mat-paginator [pageSizeOptions]="[10, 20, 50]" #TablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
  </div>
</mat-card>
 